import { Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { MenuItem } from '@components/menu';
import { DeleteIcon, MoveTaskIcon } from '@sketchnote/icons';
import cn from 'classnames';
import { useState } from 'react';

const bulkTaskMenu = [
  { label: 'Move task to', value: 'move', icon: <MoveTaskIcon /> },
  { label: 'Delete', value: 'delete', icon: <DeleteIcon wrapperClass="text-red-500" /> },
];

export const BulkActions = ({
  onClickMenuItem,
  selectedItems,
}: {
  onClickMenuItem: (value: string) => void;
  selectedItems: string[];
}) => {
  const [isBulkActionOpen, setIsBulkActionOpen] = useState(false);

  const handleMenuClick = (value: string) => {
    onClickMenuItem(value);
  };

  return (
    <div className="flex items-center mr-8">
      <div className="flex flex-shrink-0 items-center text-gray-500 text-xs mr-8">
        {selectedItems.length} items selected
      </div>
      <Popover
        isOpen={isBulkActionOpen}
        onClose={() => setIsBulkActionOpen(false)}
        onOpen={() => setIsBulkActionOpen(true)}
      >
        <PopoverTrigger>
          <div
            className="text-white font-medium text-sm px-6 h-auto w-auto px-6 py-4 bg-primary-500 rounded-md"
            role="button"
          >
            Actions
          </div>
        </PopoverTrigger>
        <PopoverContent>
          <div className="flex flex-col bg-white relative shadow-md rounded-md">
            {bulkTaskMenu.map((menu) => (
              <MenuItem
                key={menu.value}
                style={{
                  paddingLeft: '12px',
                  paddingRight: '18px',
                  color: '#030712',
                  fontWeight: '400',
                }}
                className="w-full py-8 flex text-sm items-center"
                onClick={() => handleMenuClick(menu.value)}
              >
                {menu.icon}
                <span
                  className={cn('align-middle text-sm font-normal ml-8', {
                    'text-red-500': menu.value === 'delete',
                  })}
                >
                  {menu.label}
                </span>
              </MenuItem>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
